export enum NewsActionsEnum {
  NEWS_GET_DATA = 'NEWS_GET_DATA',
  NEWS_SET_DATA = 'NEWS_SET_DATA',
}
